export default function inBusiness({ next, to, router, store }) {
  const business = store.getters.authUser.business;

  if (!business) {
    store.dispatch("getAuthUser").then(() => {
      if (!store.getters.authUser.business)
        return router.replace("/business-registration");
      else next();
    });
  } else {
    next(); // make sure to always call next()!
  }
}
